export default __webpack_public_path__ + "static/leases-b3192dec8b68135dd021a8811f9ec830.png";